import { ActionTypes } from '../actions/actionTypes';
import { ICategoryAction } from '../../interfaces/action';
import { ICategoryState } from '../../interfaces/state/ICategoryState';

const initialState: ICategoryState = {
  categories: [],
  loading: false,
  error: null,
  fetched: false,
};

const categoryReducer = (state = initialState, action: ICategoryAction): ICategoryState => {
  switch (action.type) {
    case ActionTypes.CATEGORY_FIND_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ActionTypes.CATEGORY_FIND_SUCCESS:
      return {
        ...state,
        categories: action.categories || [],
        loading: false,
        fetched: true,
      };
    case ActionTypes.CATEGORY_FIND_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error || null,
        fetched: true,
      };
    default:
      return state;
  }
};

export default categoryReducer;
